<div class="d-flex justify-content-center  row   no-margin no-padding">

  <div *ngIf="event &&!loading" class=" col-12 col-md-12   no-padding  " style="    height: 340px;  margin-top: 45px;background-image: url('../../../assets/imgs/izidrink-home-bar-banner.jpg');      filter: blur(10px) grayscale(100%);;">
    
  </div>

  <div  style="    z-index: 1;  position: absolute;  top: 4.5rem" class="    d-flex justify-content-center">
    <div *ngIf="event &&!loading" class="col-12 col-sm-8  col-md-6 col-lg-5 col-xl-5 col-xxl-4   d-flex justify-content-center ">
      <div class="col-12 col-md-12">
        <img class="mt-2 imgEvent shadow-div" src="{{event.image}}" alt="">
      </div>
    </div>



  </div>



  <div *ngIf="loading" class=" row col-12 d-flex justify-content-center mt-5">
    <app-spinner-loading></app-spinner-loading>
  </div>

  <div *ngIf="!loading" class="container no-padding mb-5">
    <div class="d-flex justify-content-center ">
      <div class="row col-12 d-flex justify-content-center mt-4 no-padding">

        <div class="col-12 row d-flex justify-content-center text-center no-padding mb-3">

          <h2 class=" text-truncate text-uppercase">{{event.name}}</h2>

          <div class="col-12 col-md-12 d-flex justify-content-center mb-2">
            <div class="col-8 col-md-3 ">
              <img src="../../../assets/texts/tickets-buy.svg" style="width: 100%" alt="">
            </div>

          </div>

          <app-div-no-result *ngIf="!tickets.length"></app-div-no-result>

          <div *ngFor=" let ticket of tickets" class="col-12 mt-2 mb-2  ">
            <app-card-ticket class="d-flex justify-content-center" [product]="ticket"></app-card-ticket>
          </div>


          <div [ngClass]="disableButton()?'inVisibleButtonCheckOut':'visibleButtonCheckOut' "
            class="  col-12 col-md-8 col-lg-6 col-xl-6 d-flex justify-content-center mt-5 mb-5">
            <button mat-raised-button class="col-12" color="warn" [disabled]="disableButton()" (click)="openTypePay()">
              <!-- (click)="checkout()" -->
              <mat-icon>shopping_cart</mat-icon> Ir a Pagar
              <!-- : {{totalCart+totalService|number}} -->


            </button>
          </div>


        </div>



      </div>
    </div>
  </div>



  <!-- google-maps-demo.component.html -->
  <!-- 
  <div *ngIf="apiLoaded | async">
    <google-map></google-map>
  </div> -->

  <div *ngIf="event.idMenu && !loading" class=" buttomMenu shadow-div text-center " style="    display: flex;
justify-content: center;
align-items: center;">

    <div class="col-12">
      <button routerLink="/menus/{{event.idMenu}}" color="primary" mat-mini-fab aria-label=""
        class="col-12 no-shadow   ">
        <mat-icon class="no-margin no-padding">menu_book</mat-icon>

      </button>
      <p style="    font-size: 11px;
        margin-top: -6px;" class="text-center">Carta</p>
    </div>



  </div>
</div>
